import ContactInformation from './ContactInformation.component';

export default ContactInformation;
